/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function noop() { }
//# sourceMappingURL=noop.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/noop.js
// module id = 928
// module chunks = 2